export const adicionarMinutos = (
  horaInicial: string | null,
  quantidadeMinutos: string,
) => {
  if (!horaInicial) {
    return '';
  }

  const [horas, minutos] = horaInicial.split(':').map(Number);

  const data = new Date();
  data.setHours(horas);
  data.setMinutes(minutos);

  data.setMinutes(data.getMinutes() + Number(quantidadeMinutos));

  const horaFinal = data.getHours().toString().padStart(2, '0');
  const minutoFinal = data.getMinutes().toString().padStart(2, '0');

  return `${horaFinal}:${minutoFinal}`;
};
